export type GeckoAssetLensLocationJSON = {
  id?: string
  name?: string
  site?: string
  orgId?: string
  parent?: string[]
  description?: string
  hierarchyId?: string[]
}
